import Axios from "@/plugins/Axios";

export class ObjetivosAprendizagem {
  async pesquisar(query, gestaoId) {
    const response = await Axios().get(
      `planos-bimestrais-infantil/objetivos-aprendizagem?query=${query}&gestao_id=${gestaoId}`
    );
    return response;
  }
}

export default new ObjetivosAprendizagem();
